module.exports = __webpack_public_path__ + "static/media/Lato-Black.a54bddbc.ttf";